export default __webpack_public_path__ + "static/media/BloodGlucose.08586789.svg";